export default class NumericPrefix {
  phonePrefix: string;
  isoCode2: string[];
  isoCode3: string[];

  of(prefix: string, isoCode2: string[], isoCode3: string[]): NumericPrefix {
    this.phonePrefix = prefix;
    this.isoCode2 = isoCode2;
    this.isoCode3 = isoCode3;
    return this;
  }
}
